var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/user/forgot-password/form-field.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(!runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"forgotPassword")),"showPasswordResetSent")) {
output += "\n\n    <div class=\"c-form__field c-form__field--required ";
output += runtime.suppressValue((lineno = 2, colno = 64, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "hasErrors"), "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"forgotPassword")),"messages")),"email")])), env.opts.autoescape);
output += "\">\n\n        <label for=\"email\" class=\"c-modal-form__label\">\n            ";
output += runtime.suppressValue((lineno = 5, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-login_email",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n        </label>\n\n        <input type=\"email\" id=\"login-email\" name=\"email\" class=\"c-form__text c-modal-form__email\"\n            data-qa-forgot-password-email\n            ";
if(!runtime.contextOrFrameLookup(context, frame, "renderedOutsideOfModal")) {
output += "data-parsley-type=\"email\"\n            ";
output += runtime.suppressValue((lineno = 12, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "validatedField"), "validatedField", context, ["ERROR_RESET_PASSWORD_INVALID_USERNAME"])), env.opts.autoescape);
;
}
output += "\n            value=\"";
output += runtime.suppressValue(env.getFilter("default").call(context, (runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"forgotPassword")),"email") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"login")),"email"))), env.opts.autoescape);
output += "\"\n            aria-required=\"true\"\n            aria-describedby=\"login-email_error\"/>\n        ";
output += runtime.suppressValue((lineno = 17, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "displayFieldErrors"), "displayFieldErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"modal")),"forgotPassword")),"messages")),"email"),runtime.makeKeywordArgs({"id": "login-email_error"})])), env.opts.autoescape);
output += "\n\n    </div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/user/forgot-password/form-field.j2"] , dependencies)